import React, {Component} from 'react';
import {connect} from "react-redux";
import ReactLoading from 'react-loading';
import SyllabusLecture from './SyllabusLecture';
import * as VideoActions from '../../store/actions/videoActions';
/* global $ */

class Syllabus extends Component {

    componentDidMount(){
        if(this.props.courseUser[0]){
            this.props.getSyllabus(this.props.courseUser[0].id);
        }
    }

    componentDidUpdate(props){
        if(this.props.courseUser[0]){
            if(this.props.courseUser[0].id !== props.courseUser[0].id){
                this.props.getSyllabus(this.props.courseUser[0].id);
            }
        }
    }

    render(){

        if(!this.props.courseUser){
            return null;
        }
        if(!this.props.courseUser[0]){
            return null;
        }
        if(!this.props.courseUser[0].subjectOrder){
            return null;
        }

        return (
            <div id="SyllabusPane">
                <div className="SyllabusBackdrop" onClick={e => {
                    $("#SyllabusPane").toggleClass("acitveSyllabusPane");
                    $('#content-container.blur').removeClass('blur');
                }}></div>

                {!this.props.courseUser[0].id ?
                    <div className="nl-container">
                        <ReactLoading type={"spin"} />
                    </div>

                    :
                    <div className="SyllabusContent">
                        <div className="flex flex-justify-content-space-between flex-align-items-center">
                            <h3 className="font-20 sm-bottom20"><i className="zmdi zmdi-arrow-back sm-right10 HandIcon" onClick={e => {
                    $("#SyllabusPane").toggleClass("acitveSyllabusPane");
                    $('#content-container.blur').removeClass('blur');
                }}></i> Syllabus</h3>
                        </div>
                        {this.props.syllabus && this.props.courseUser[0] ?
                            this.props.courseUser[0].subjectOrder.map((sub, i) => {
                            if(this.props.syllabus.subjects){
                                let subject = this.props.syllabus.subjects.filter(s => s.id === sub)[0];


                                if(subject){
                                
                                    return (
                                        <div className="panel customPanel" key={i}>
                                            <div className={`panel-heading border-bottom ${this.props.courseUser[0].currentSubject === subject.id ? '' : 'collapsed'}`} data-toggle="collapse" data-target={`#SyllabusCoursePhysics-${i}`} aria-expanded="false">
                                                <div className="flex flex-justify-content-space-between flex-align-items-center HandIcon">
                                                    <h3 className="panel-title text-white"><i className='zmdi zmdi-chevron-down font-16'></i> {subject.name}</h3>
                                                    <div className="sp-right10">{subject.completedPercent ? subject.completedPercent : 0}%</div>
                                                </div>
                                                <div className="progressBarWrapSyllabus">
                                                    <div className="progressBarSyllabus bg-success" style={{width: String(subject.completedPercent ? subject.completedPercent : 0) + '%'}}></div>
                                                </div>
                                            </div>

                                            <div className={`panel-body collapse ${this.props.courseUser[0].currentSubject === subject.id ? 'in' : ''}`} id={`SyllabusCoursePhysics-${i}`} aria-expanded="false">
                                                <ul>
                                                    {subject.chapters.map((chapter, index) => {

                                                        return <SyllabusLecture chapter={chapter} key={index} index={index} progress={chapter.completedPercent} />
                                                    })}
                                                    
                                                </ul>
                                            </div>
                                        </div>        
                                    )
                                }
                            }
                            
                        })
                    : null}
                        
            
                    </div>
                }
            </div>
                
        )
    }
}

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    getSyllabus: (cuId) => {
        dispatch(VideoActions.getSyllabus(cuId));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Syllabus);


// WEBPACK FOOTER //
// ./src/components/Common/Syllabus.js